import { render } from "./ProductSampleRequest.vue?vue&type=template&id=341feed0"
import script from "./ProductSampleRequest.vue?vue&type=script&lang=js"
export * from "./ProductSampleRequest.vue?vue&type=script&lang=js"

import "./ProductSampleRequest.vue?vue&type=style&index=0&id=341feed0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__